<template>
  <section class="app-main">
    <div class="w-100 h-100 bg-white of-scroll-y">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  computed: {
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  },
};
</script>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue